module.exports = __webpack_public_path__ + "static/img/egg_b_18.cb3761a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_18.png
// module id = XouJ
// module chunks = 1